module.exports = __webpack_public_path__ + "img/综合服务平台开发流程图.41ffc33e.jpg";